import script from "./WinBackEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./WinBackEmail.vue?vue&type=script&setup=true&lang=js"

import "./WinBackEmail.vue?vue&type=style&index=0&id=fbda5e2a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\data_dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbda5e2a"]])

export default __exports__